module.exports = __webpack_public_path__ + "static/media/IMG-4.1ae583f7.jpg";